const VENDOR_ALIGN_BAR_SELECTOR =
  '[style*="z-index: 999"][style*="translate(-50%, -50%)"]';

export const hideVendorImageAlignBars = (root: ParentNode): void => {
  root
    .querySelectorAll<HTMLElement>(VENDOR_ALIGN_BAR_SELECTOR)
    .forEach((el) => {
      el.style.display = "none";
    });
};
